import React, { Component } from 'react'
import styled from 'styled-components'

import Layout from '../components/layouts'
import {
    Container
} from '../components/styledComponents'

import { YMaps, Map, Placemark } from 'react-yandex-maps'

import Form from '../components/forms/Feedback'

const mapState = { center: [59.942624, 30.364153], zoom: 16 }

const StyledContainer = styled(Container)`
  .response-window {
    margin: 20px auto;
    box-shadow: none;
  }
`

const Title = styled.h1`
  margin-bottom: 60px;
  @media (max-width: 991px) {
    margin-bottom: 25px;
  }  
`

const MapContainer = styled.div`
  width: 100vw;
  min-height: 530px;
  position: relative;
  left: calc(-50vw + 50%);
  @media (max-width: 991px) {
    min-height: 250px;
    margin: 0 0 15px;
  }  
`

const ContactData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 150px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
  }  
  div {
    display: flex;
    align-items: center;
    color: #2d2d2d;
    font-size: 18px;
    font-family: montserrat-bold;
    img {
      margin-right: 24px;
    }
  }
  a {
    color: #2d2d2d;
  }
`
const Separator = styled.div`
  width: 100vw;
  height: 1px;
  background-color: #f2f2f2;
  position: relative;
  left: calc(-50vw + 50%);
  margin-bottom: 20px;
`
const StyledForm = styled(Form)`
  box-shadow: none;
  margin: 0 auto;
`

export default class Contacts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            height: 530
        }
    }

    componentDidMount() {
        document.body.style.background = "#fff"
        this.setState({height: window.innerWidth < 992 ? 250 : 530})
    }

    render() {

        const { height } = this.state;
        //console.log('h', height)

        return (
            <Layout>
                <StyledContainer>
                    <Title>Контакты</Title>
                    <MapContainer>
                        <YMaps>
                            <Map state={mapState} width={-1} height={height} instanceRef={ref => { ref && ref.behaviors.disable('scrollZoom') }}>
                                <Placemark
                                    geometry={{
                                        type: 'Point',
                                        coordinates: [59.942624, 30.364153]
                                    }}
                                    properties={{
                                        iconContent: 'ул. Радищева, д. 39, литера Д, офис 312'
                                    }}
                                    options={{
                                        preset: 'islands#blueStretchyIcon'
                                    }}
                                />
                            </Map>
                        </YMaps>
                    </MapContainer>
                    <ContactData>
                        <div>
                            <img alt='Адрес' src='/static/images/location.png' />
                            Санкт-петербург<br />
                            ул. Радищева, д. 39, литера Д, офис 312
                        </div>
                        <div>
                            <img alt='Телефон' src='/static/images/phone.png' />
                            <a href="tel:+78123093645">7-812-309-36-45</a>
                        </div>
                        <div>
                            <img alt='email' src='/static/images/mail.png' />
                            <a href="mailto:office@cursusts.com">office@cursusts.com</a>
                        </div>
                    </ContactData>
                    <Separator />
                    <StyledForm className="page-form" />
                </StyledContainer>
            </Layout>
        )
    }
}